// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29-Vr","footer":"styles_footer__Zk8sz","passCodeTooltip":"styles_passCodeTooltip__3adMl"};